import { Suspense } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
// components
import Logo from "../Logo";
import Loader from "../Loader";

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: "100%",
  position: "absolute",
  padding: theme.spacing(2, 0, 0),
  "& > img": {
    height: 50,
    margin: "auto",
  },

  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3, 3, 0),

    "& > img": {
      height: 70,
      margin: "inherit",
    },
  },
}));

export default function LogoOnlyLayout({ disabledLink }) {
  return (
    <>
      <HeaderStyle>
        <Logo disabledLink={disabledLink} />
      </HeaderStyle>

      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </>
  );
}
